<template>
  <v-dialog v-model="dialog">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on" v-if="item">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      <v-btn v-else color="secondary" dark class="mb-2" v-on="on">
        <v-icon left>mdi-plus</v-icon>Nuevo
      </v-btn>
    </template>
    <v-card>
    <v-toolbar elevation="0">
      <v-toolbar-title>{{ item ? 'Actualizar' : 'Crear'}} trámite</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="dialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

      <v-card-text>
        <FormalityForm :item="item"></FormalityForm>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import FormalityForm from '@/components/FormalityForm.vue'
export default {
  name: 'FormalityDialog',
  data () {
    return {
      dialog: false
    }
  },
  props: {
    item: Object
  },
  components: {
    FormalityForm
  }
}
</script>
